export const getInvoiceByBookingId = (bookingId, invoices) => {
  if (!bookingId || !Array.isArray(invoices)) return null;

  return invoices.find(invoice => invoice.booking === bookingId) || null;
};
